import script from "./LightReminder.vue?vue&type=script&setup=true&lang=js"
export * from "./LightReminder.vue?vue&type=script&setup=true&lang=js"

import "./LightReminder.vue?vue&type=style&index=0&id=29bc27ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29bc27ce"]])

export default __exports__